import React from "react";
import {Navigate,Outlet} from 'react-router-dom'

const CheckResetPasswordComponent = ()=>{

    const otp_verify = sessionStorage.getItem('otp_verify');
    return otp_verify?<Outlet />:<Navigate to="/login" />
}

export default CheckResetPasswordComponent;